const apiKeys = {
  firebaseConfig: {
    apiKey: 'AIzaSyByhsxqvQt5cmwvSa9k051pfXTW7J-bKMw',
    authDomain: 'anime-showdown.firebaseapp.com',
    databaseURL: 'https://anime-showdown.firebaseio.com',
    projectId: 'anime-showdown',
    storageBucket: 'anime-showdown.appspot.com',
    messagingSenderId: '1073332900913',
  },
};

export default apiKeys;
